export default __webpack_public_path__ + "static/media/angularcli.cd33c4ce.webp";